import React from 'react'
import { ThemeProvider } from '@material-ui/styles'
import { Button } from '@material-ui/core'

const ButtonWidget = (props) => {
  const { theme, cardUrl, text, variant = 'contained' } = props

  return (
    <ThemeProvider theme={theme}>
      <Button
        target="_blank"
        href={cardUrl}
        style={{ backgroundColor: theme.palette.primary.main }}
        variant={variant}
      >
        {text}
      </Button>
    </ThemeProvider>
  )
}
export default ButtonWidget
